export const DK_DRAFT_KEY = "mbs_dk_gelismis_draft_v1";

/** Kurumsal PDF şablonları — backend `sablon` parametresi ile eşleşir. */
export const DK_PDF_SABLONLARI = [
    {
        id: "hesap",
        etiket: "Hesap Raporu",
        aciklama: "Detaylı metodoloji, formül ve parça dökümü — iç kullanım",
        icon: "calculator",
        renk: "emerald",
    },
    {
        id: "ucuncu_kisi",
        etiket: "3. Kişi Bildirimi",
        aciklama: "Sigorta şirketi / karşı taraf bilgilendirme ve talep yazısı",
        icon: "mail",
        renk: "sky",
    },
    {
        id: "bilirkisi_uzman",
        etiket: "Bilirkişi / Uzman Görüşü",
        aciklama: "Mahkeme, hakem heyeti ve tahkim için resmî uzman raporu",
        icon: "scale",
        renk: "gold",
    },
];

export const FALLBACK_SABLONLAR = [
    {
        id: "on_hafif",
        etiket: "Ön çarpma hafif",
        diagram_ids: ["on_tampon", "on_kaput", "sol_on_far", "sag_on_far"],
        varsayilan_islem: "onarim",
    },
    {
        id: "on_orta",
        etiket: "Ön çarpma orta",
        diagram_ids: [
            "on_tampon",
            "on_kaput",
            "sol_on_far",
            "sag_on_far",
            "sol_on_camurluk",
            "sag_on_camurluk",
            "motor_kaputu_alt",
        ],
        varsayilan_islem: "boya",
    },
    {
        id: "yan_darbe",
        etiket: "Yan darbe",
        diagram_ids: [
            "sol_on_kapi",
            "sag_on_kapi",
            "sol_on_camurluk",
            "sag_on_camurluk",
            "sol_ayna",
            "sag_ayna",
        ],
        varsayilan_islem: "boya",
    },
    {
        id: "arka_carpma",
        etiket: "Arka çarpma",
        diagram_ids: ["arka_tampon", "bagaj_kapagi", "sol_arka_camurluk", "sag_arka_camurluk"],
        varsayilan_islem: "boya",
    },
];

export const PERT_HASAR_KODLARI = new Set(["pert", "cok_agir"]);
